import { Result, PagedResult } from "../../../models/Result";
import { httpService } from "../../HttpService";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";
import { ApiScopeViewModel, CreateApiScopeRequest, UpdateApiScopeRequest } from "../../../models/ApiScopeModel";

class ApiScopeApiService {
    private baseApiUrl = process.env.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_AUTH_API_BASE_URL;
    private path: string = "Scope";

    Search = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<ApiScopeViewModel[]>> =>
        await httpService.getPage<ApiScopeViewModel[]>(`/${this.path}/search`, searchRequest, { baseURL: this.baseApiUrl });

    GetById = async (name: string): Promise<Result<ApiScopeViewModel>> =>
        await httpService.get<ApiScopeViewModel>(`/${this.path}/${name}`, { baseURL: this.baseApiUrl });

    Create = async (model: CreateApiScopeRequest): Promise<Result<unknown>> =>
        await httpService.post<unknown>(`/${this.path}`, model, { baseURL: this.baseApiUrl });

    Update = async (name: string, model: UpdateApiScopeRequest): Promise<Result<unknown>> =>
        await httpService.put<unknown>(`/${this.path}/${name}`, model, { baseURL: this.baseApiUrl });

    Delete = async (name: string): Promise<Result<unknown>> =>
        await httpService.delete<unknown>(`${this.baseApiUrl}/${this.path}/${name}`);
}

const apiScopeApiService = new ApiScopeApiService();

export { apiScopeApiService };
